import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Network } from '@root/entities/network'
import { isTauriAtom, PlatformUtil } from '@root/shared'

import type { PairModel } from '@root/entities/pair/atoms'

type Props = {
  pair: PairModel
}

export const TradingAuditDevHolding: React.FC<Props> = ({ pair }) => {
  const [isTauri] = useAtom(isTauriAtom)
  const [audit] = useAtom(pair.audit)
  const [txCreator] = useAtom(pair.initTxCreator)

  const explorerLink = txCreator?.address
    ? Network.makeExplorerContractLink(pair.base.network, txCreator.address)
    : undefined

  return (
    <Root>
      {/* <BackingIcon size={16} /> */}
      <ValueLink
        as={explorerLink ? 'a' : 'div'}
        onClick={() => {
          if (isTauri && explorerLink) {
            PlatformUtil.openLink(explorerLink, '_blank')
          }
        }}
        href={explorerLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>
          <Numeric
            value={audit.checks.ownerTokenBalance.percent}
            preset="percents"
          />
          %
        </span>
      </ValueLink>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  gap: 4px;
`
const Value = styled.div``
const ValueLink = styled(Value).attrs({ as: 'a' })``
